import { EntityApi } from "../../services/ApiPlatform";

export abstract class SkillCriteriaApi extends EntityApi {
    protected static GET_COLLECTION = "/api/skill-criterias";

    protected static POST_COLLECTION = "/api/skill-criterias";

    protected static GET_ITEM = "/api/skill-criterias/{id}";

    protected static PUT_ITEM = "/api/skill-criterias/{id}";

    protected static PATCH_ITEM = "/api/skill-criterias/{id}";

    protected static DELETE_ITEM = "/api/skill-criterias/{id}";
}
